import { ModalHandler } from '@app-velocity/ui';

import { RemoveFigmaReportModalContent } from './components/RemoveFigmaReportModalContent';

export const RemoveFigmaReportModal = () => {
  return (
    <ModalHandler channel="prototypes" id="delete-figma-report">
      <RemoveFigmaReportModalContent />
    </ModalHandler>
  );
};
